export function attachHeader(config, name, value) {
  const headers = config.headers
  if (headers && typeof headers.set === 'function') headers.set(name, value)
  else config.headers = { ...config.headers, [name]: value }
}

export function readHeader(config, name) {
  const headers = config?.headers
  if (!headers) return undefined
  if (typeof headers.get === 'function') return headers.get(name)
  return headers[name]
}
